import React, { useEffect } from 'react';
import { observer } from 'mobx-react';

import { toDate } from 'shared/utilities';
import { useObservable } from 'shared/hooks';
import { DateType } from 'shared/types';

import { CALENDAR_PAGE } from 'pages/calendar/constants/CALENDAR_PAGE';

import './styles.scss';

type PropsType = {
    date: DateType;
};

export const CalendarPageDaysTimeline = observer(function CalendarPageDaysTimeline({ date }: PropsType) {
    const store = useObservable({
        now: toDate(),
    });

    const hasTimeline = store.now.isSame(date, 'day') && store.now.hour() > CALENDAR_PAGE.HOURS[0] && store.now.hour() < CALENDAR_PAGE.HOURS[CALENDAR_PAGE.HOURS.length - 1];

    useEffect(() => {
        const interval = setInterval(() => {
            store.set('now', toDate());
        }, 10000);
        return () => clearInterval(interval);
    }, [store]);

    if (!hasTimeline) {
        return null;
    }

    return (
        <div className="calendar-page-days-day-timeline"
             style={{ top: (store.now.hour() - CALENDAR_PAGE.HOURS[0]) * CALENDAR_PAGE.HOUR_HEIGHT + (store.now.minute() * CALENDAR_PAGE.HOUR_HEIGHT) / 60 }}>
            <div className="calendar-page-days-day-timeline__time">{store.now.format('HH:mm')}</div>
            <div className="calendar-page-days-day-timeline__point" />
        </div>
    );
});
